// Third party
import axios from 'axios';

// Components
import { getAuthHeaders } from '../utils';
import { REACT_APP_DATA_API_URL, DEV_APP_API_URL } from '../constants';
import { TGetRepetitionReq, TGetWeaponPresentationReq } from '../types/requests';

export function ShootingDataController() {
  const getSessions = async <T>(): Promise<T> => {
    return await axios.get(`${DEV_APP_API_URL}/session/`, {
      headers: getAuthHeaders(),
    });
  };

  const getScenarios = async <T>({ userId, sessionId }: { userId: number, sessionId: number }): Promise<T> => {
    return await axios.get(`${REACT_APP_DATA_API_URL}/metrics/users/${userId}/performance/scenario`,  {
      params: {
        session_id: sessionId
      }
    });
  };

  const getTransactions = async <T>(id: number): Promise<T> => {
    return await axios.get(`${DEV_APP_API_URL}/transactions/${id}`, {
      headers: getAuthHeaders(),
    });
  };

  const getRepetitions = async <T>({ userId, sessionId, scenarioId }: TGetRepetitionReq): Promise<T> => {
    return await axios.get(`${REACT_APP_DATA_API_URL}/metrics/users/${userId}/performance/repetition`,  {
      params: {
        session_id: sessionId,
        scenario_id: scenarioId,
      },
    });
  };

  const getWeaponPresentation = async <T>({ userId, sessionId, scenarioId, drillName, repetitionNumber }: TGetWeaponPresentationReq): Promise<T> => {
    return await axios.get(`${REACT_APP_DATA_API_URL}/metrics/users/${userId}/weapon_presentation`,  {
      params: {
        session_id: sessionId,
        scenario_id: scenarioId,
        drill: drillName,
        ...(repetitionNumber != null
          ? { repetition_number: repetitionNumber }
          : {}),
      },
    });
  };

  const getStabilityPresentation = async <T>({ userId, sessionId, scenarioId, drillName, repetitionNumber }: TGetWeaponPresentationReq): Promise<T> => {
    return await axios.get(`${REACT_APP_DATA_API_URL}/metrics/users/${userId}/stability_presentation`,  {
      params: {
        session_id: sessionId,
        scenario_id: scenarioId,
        drill: drillName,
        ...(repetitionNumber != null
          ? { repetition_number: repetitionNumber }
          : {}),
      },
    });
  };

  return { getSessions, getScenarios, getRepetitions, getTransactions, getWeaponPresentation, getStabilityPresentation };
}
